<template>
  <div class="content-editor-block uploaded-video">

    <video v-if="mValue" autoplay="autoplay" muted="true" loop="true" style="width: 100%;">
      <source :src="mValue" type="video/mp4">
    </video>

    <el-input v-model="mValue" @input="onInput" placeholder="請輸入影片網址"></el-input>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    }
  },
  data: () => {
    return {
      mValue: '',
      timer: null
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.mValue = this.value
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
